import { Box, Container, Grid, Typography } from "@material-ui/core";
import React, { useState } from "react";
import "./UserQuotes.css";

const UserClosed = () => {
  const [activeColor, setActiveColor] = useState("Accept");
  return (
    <div>
      <div className="view_quotes">
        <Container>
          <Box className="view_quotes_card_main">
            <Grid container spacing={2}>
              <Grid item xs={12} lg={4} md={4}>
                <Box className="view_quotes_card">
                  <Box>
                    <Typography variant="h6">Quote No: QT22101801 </Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6">Dated: Oct. 18, 2022</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6"> Ref: RFQ708040</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} lg={4} md={4}>
                {" "}
                <Box className="view_quotes_card">
                  <Box>
                    <Typography variant="h6">John Doe</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6">Operation Manager</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6">ABC LLC</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} lg={4} md={4}>
                {" "}
                <Box className="view_quotes_card">
                  <Box>
                    <Typography variant="h6">Address</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6"> Email</Typography>
                  </Box>
                  <Box>
                    <Typography variant="h6">Contact</Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Container>
            <Box className="user_quote_text">
              <Typography variant="h6">Dear Mr. John Doe</Typography>
              <Typography variant="h6">
                Subject: Transportation of 8000 LTRS X4 Multi compartment tanker
                for lube oil from Dubai - Saudi
              </Typography>
              <Typography variant="h6">
                Thank you very much for showing interest and having trust on our
                services. Understanding your requirements, we are pleased to
                offer our best possible prices for the following
              </Typography>
            </Box>
          </Container>

          <Box className="user_quote_heading">
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={1} md={1}>
                  <Typography variant="h6">S.No</Typography>
                </Grid>
                <Grid item xs={12} lg={5} md={5}>
                  <Typography variant="h6">Description</Typography>
                </Grid>
                <Grid item xs={12} lg={2} md={2}>
                  <Typography variant="h6">Rate</Typography>
                </Grid>
                <Grid item xs={12} lg={4} md={4}>
                  <Typography variant="h6">Remarks</Typography>
                </Grid>
              </Grid>
            </Container>
          </Box>

          <Box className="user_quote_content">
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={1} md={1}>
                  <Typography variant="h6">1</Typography>
                </Grid>
                <Grid item xs={12} lg={5} md={5}>
                  <Typography variant="h6">
                    Transportation (Dubai to Saudi)
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={2} md={2}>
                  <Typography variant="h6">AED 10,000</Typography>
                </Grid>
                <Grid item xs={12} lg={4} md={4}></Grid>
              </Grid>
            </Container>
          </Box>
          <Box className="user_quote_content">
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={1} md={1}>
                  <Typography variant="h6">1</Typography>
                </Grid>
                <Grid item xs={12} lg={5} md={5}>
                  <Typography variant="h6">
                    Transportation (Dubai to Saudi)
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={2} md={2}>
                  <Typography variant="h6">AED 10,000</Typography>
                </Grid>
                <Grid item xs={12} lg={4} md={4}></Grid>
              </Grid>
            </Container>
          </Box>
          <Box className="user_quote_content">
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={1} md={1}>
                  <Typography variant="h6">1</Typography>
                </Grid>
                <Grid item xs={12} lg={5} md={5}>
                  <Typography variant="h6">
                    Transportation (Dubai to Saudi)
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={2} md={2}>
                  <Typography variant="h6">AED 10,000</Typography>
                </Grid>
                <Grid item xs={12} lg={4} md={4}></Grid>
              </Grid>
            </Container>
          </Box>
          <Box className="user_quote_content">
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={1} md={1}>
                  <Typography variant="h6">1</Typography>
                </Grid>
                <Grid item xs={12} lg={5} md={5}>
                  <Typography variant="h6">
                    Transportation (Dubai to Saudi)
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={2} md={2}>
                  <Typography variant="h6">AED 10,000</Typography>
                </Grid>
                <Grid item xs={12} lg={4} md={4}></Grid>
              </Grid>
            </Container>
          </Box>
          <Box className="user_quote_content">
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={12} md={12}>
                  <Typography variant="h5">Terms and Conditions</Typography>
                </Grid>
              </Grid>
            </Container>
          </Box>
        </Container>
      </div>
      <Container>
        <div className="view_quote_btn">
          <Box>
            <button
              onClick={() => setActiveColor("Accept")}
              className={`quote_btn ${
                activeColor === "Accept" ? "quote_btn_active" : "quote_btn"
              }`}
            >
              Back
            </button>
          </Box>
        </div>
      </Container>
    </div>
  );
};

export default UserClosed;
